import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Thin redirect CTA: entering /creator/contracts/new bounces the user to the
// contract templates picker which is where a new draft starts. Keeping the
// extra URL (instead of inline navigate) so the Billing "Remaining" tile
// has a named destination we can screenshot/link to.
export default function CreatorContractsNewCTA() {
  const navigate = useNavigate();
  useEffect(() => { navigate('/creator/contracts/templates', { replace: true }); }, [navigate]);
  return (
    <div data-testid="creator-contracts-new-cta" style={{ padding: '40px', color: '#5B6472' }}>
      Redirecting to contract templates…
    </div>
  );
}
